import { InvoiceUpdateDnd } from '../../modern/components/invoices/invoice-update/invoice-update-dnd/invoice-update-dnd';
import { QuoteUpdateComponent } from '../../modern/components/quotes/quote-update/quote-update';
import { QuoteSummaryBlockComponent } from '../../modern/components/quotes/common/quote-summary-block/quote-summary-block';
import { HybridHelper } from '../../upgrade/upgradeHelper';
import { SnLabelComponent } from '../../../shared/components/common/sn-label/sn-label';
import { SnWarningComponent } from '@components/common/sn-warning/sn-warning';
import { SettingsBtnComponent } from '../../modern/components/buttons/settings-btn/settings-btn';
import { BtnSubscriptionComponent } from '../../modern/components/buttons/btn-subscription/btn-subscription';
import { JobClientComponent } from '../../modern/components/client/job-client/job-client';
import { SendBtnComponent } from '../../modern/components/buttons/send-btn/send-btn';
import { EditBtnComponent } from '../../modern/components/buttons/edit-btn/edit-btn';
import { EnableGdprSectionComponent } from '../../modern/components/settings/gdpr/enable-gdpr-section/enable-gdpr-section';
import { CloseBtnComponent } from '../../../shared/components/common/buttons/close-btn/close-btn';
import { ClientCardComponent } from '../../modern/components/client/client-card/client-card';
import { DeleteBtnComponent } from '../../modern/components/buttons/delete-btn/delete-btn';
import { SubscribeClientBtnComponent } from '../../modern/components/buttons/subscribe-client-btn/subscribe-client-btn';
import { OptInAgreementComponent } from '../../../shared/components/common/opt-in-agreement/opt-in-agreement';
import { CollapsePanelComponent } from '@web-components/common/collapse-panel/collapse-panel.component';
import { EnableClientsOptInComponent } from '../../modern/components/client/enable-clients-opt-in/enable-clients-opt-in';
import { ClientPhotoWebComponent } from '../../modern/components/client/client-photo/client-photo';
import { ResubscribeClientModalWebComponent } from '../../modern/components/client/modals/resubscribe-client-modal/resubscribe-client-modal';
import { UploadPhotoModalWebComponent } from '../../modern/components/client/modals/upload-photo-modal/upload-photo-modal';
import { ContractSignatureComponent } from '../../modern/components/contract/contract-signature/contract-signature';
import { QuestionnaireSubmittedStatementComponent } from '../../../shared/components/common/questionnaire-submitted-statement/questionnaire-submitted-statement';
import { SaveOptinConsentModalComponent } from '../../../shared/components/base/client/modals/save-optin-consent-modal/save-optin-consent-modal';
import { TermsUpdatedModalComponent } from '../../modern/components/common/terms-updated-modal/terms-updated-modal';
import { WorkflowExitModalComponent } from '../../modern/components/settings/workflow-exit-modal/workflow-exit-modal';
import { WarningSignImgComponent } from '../../../shared/components/common/warning-sign-img/warning-sign-img';
import { SearchbarComponent } from '../../modern/components/common/searchbar/searchbar';
import { SnPaginationComponent } from '../../modern/components/common/sn-pagination/sn-pagination';
import { ConsentListWebComponent } from '../../modern/components/client/consent-list/consent-list';
import { ArchiveBtnComponent } from '../../modern/components/buttons/archive-btn/archive-btn';
import { CancelBtnComponent } from '../../../mobile/src/components/buttons/cancel-btn/cancel-btn';
import { ErrorMessageModalWebComponent } from '../../modern/components/common/error-message-modal/error-message-modal';
import { AutocompleteEmailInputComponent } from '../../modern/components/inputs/autocomplete-email-input/autocompete-email-input';
import { AttachmentsComponent } from '../../../mobile/src/components/files/attachments/attachments';
import { EventTypeRowComponent } from '../../modern/components/common/event-type-row/event-type-row';
import { AddRoundBtnComponent } from '../../modern/components/buttons/add-round-btn/add-round-btn';
import { SimplePaginationComponent } from '../../modern/components/buttons/simple-pagination/simple-pagination';
import { ShootsAppointmentsBlockComponent } from '../../modern/components/dashboard/shoots-appointments-block/shoots-appointments-block';
import { RecentLeadsBlockComponent } from '../../modern/components/dashboard/recent-leads-block/recent-leads-block';
import { DeleteLeadModalComponent } from '../../modern/components/leads/modals/delete-lead-modal/delete-lead-modal';
import { UpcomingPaymentsBlockComponent } from '../../modern/components/dashboard/upcoming-payments-block/upcoming-payments-block';
import { RecordPaymentModalComponent } from '../../modern/components/payments/modals/record-payment-modal/record-payment-modal';
import { WriteOffModalComponent } from '../../modern/components/payments/modals/write-off-modal/write-off-modal';
import { DragAndDropBlockComponent } from '../../modern/components/dashboard/drag-and-drop-block/drag-and-drop-block';
import { GraphsBlockComponent } from '../../modern/components/dashboard/graphs-block/graphs-block';
import { JobTaskBlockComponent } from '../../modern/components/dashboard/job-task-block/job-task-block';
import { DeleteJobModalComponent } from '../../modern/components/jobs/modals/delete-job-modal/delete-job-modal';
import { UploadComponent } from '../../modern/components/common/upload-component/upload-component';
import { ProselectUploadComponent } from '../../modern/components/common/proselect-upload-component/proselect-upload-component';
import { PackageInfoPanelComponent } from '../../modern/components/quotes/package-info-panel/package-info-panel.component';
import { PriceTagComponent } from '../../modern/components/price-tag/price-tag.component';
import { QuoteViewComponent } from '../../modern/components/quote/quote-view/quote-view';
import { PrintBtnComponent } from '../../modern/components/buttons/print-btn/print-btn';
import { ModalDeleteQuoteComponent } from '../../modern/components/quote/modals/modal-delete-quote/modal-delete-quote';
import { ModalSendQuoteComponent } from '../../modern/components/quote/modals/modal-send-quote/modal-send-quote';
import { PackagesProductBlockComponent } from '../../modern/components/packages-product/packages-product-block/product-packages-block.component';
import { ProductDetailsModalComponent } from '../../modern/components/quotes/modals/product-details-modal/product-details-modal.component';
import { AddonsTableComponent } from '../../modern/components/quotes/addons-table/addons-table.component';
import { ProductPackageTableComponent } from '../../modern/components/quotes/product-package-table/product-package-table';
import { AddNewElementBtnComponent } from '../../modern/components/buttons/add-new-element-btn/add-new-element-btn.component';
import { AddQuoteTypeModalComponent } from '../../modern/components/quotes/modals/add-quote-type-modal/add-quote-type-modal.component';
import { ReSyncBtnComponent } from '../../modern/components/buttons/re-sync-btn/re-sync-btn';
import { InvoiceViewComponent } from '../../modern/components/invoices/invoice-view/invoice-view';
import { InvoiceUpdateComponent } from '../../modern/components/invoices/invoice-update/invoice-update';
import { GalleryViewBlockComponent } from '@web-components/integrations/connect-galleries/gallery-view-block/gallery-view-block.component';
import { ProfileComponent } from '@web-components/settings/profile/profile';
import { InvoicesViewBlockComponent } from '../../modern/components/invoices/invoices-view-block/invoices-view-block.component';
import { PaymentsOverviewComponent } from '../../modern/components/payments/payments-overview/payments-overview.component';
import { SubscriptionAnnouncementBannerComponent } from '@web-components/subscription/subscription-announcement-banner/subscription-announcement-banner';
import { SubscriptionChoosePlanComponent } from '@web-components/subscription/subscription-choose-plan/subscription-choose-plan';
import { SnQuillEditorWebComponent } from '@web-components/common/sn-quill-editor/sn-quill-editor-web';
import { ContactFormSectionComponent } from '@web-components/settings/contact-form-section/contact-form-section';
import { QuestionnaireSectionComponent } from '@web-components/settings/questionnaire-section/questionnaire-section';
import { SettingSectionHeaderComponent } from '@web-components/settings/common/setting-section-header/setting-section-header';
import { SettingSectionDescriptionComponent } from '@web-components/settings/common/setting-section-description/setting-section-description';
import { EmailReplyModalComponent } from '@web-components/settings/email-settings-section/modals/email-reply-modal/email-reply-modal.component';
import { SettingsOverviewComponent } from '@web-components/settings/settings-overview/settings-overview.component';
import { SettingsNavigationComponent } from '@web-components/settings/settings-overview/settings-navigation/settings-navigation.component';
import { UserNavbarComponent } from '@web-components/navbar/user-navbar/user-navbar.component';
import { EditCompanySectionComponent } from '@web-components/settings/edit-company-section/edit-company-section';
import { CompaniesSectionComponent } from '@web-components/settings/companies-section/companies-section.component';
import { DateTimeCalendarComponent } from '@web-components/settings/date-time-calendar/date-time-calendar';
import { CustomizeLabelsComponent } from '@web-components/settings/customize-labels/customize-labels';
import { ExportJobsModalComponent } from '@web-components/jobs/modals/export-jobs-modal/export-jobs-modal';
import { ExportLeadsModalComponent } from '@web-components/leads/modals/export-leads-modal/export-leads-modal';
import { QuestionnaireComponent } from '@web-components/questionnaire/questionnaire';
import { SmtpModalComponent } from '@web-components/settings/email-settings-section/modals/smtp-modal/smtp-modal.component';
import { JobFileSectionComponent } from '@web-components/jobs/sections/job-file-section/job-file-section.component';
import { EditContractButton } from '@web-components/jobs/modals/edit-contract-button/edit-contract-button';
import { SaveContractPdf } from '@web-components/jobs/modals/save-contract-pdf/save-contract-pdf';
import { DownloadLog } from '@web-components/jobs/modals/download-log/download-log';
import { SnQuillWebViewComponent } from '@web-components/common/sn-quill-view/sn-quill-view-web';
import { IntegrateWithXeroV2Modal } from '@web-components/settings/integrations-section/modals/integrate-with-xero-v2/integrate-with-xero-v2-modal';
import { ManageUser2faModal } from '@web-components/2fa/modals/manage-user-2fa-modal/manage-user-2fa-modal';
import { IntegrationsSection } from '@web-components/settings/integrations-section/integrations-section';
import { LeadSourcesSectionComponent } from '@web-components/settings/lead-sources-section/lead-sources-section';
import { LeadSourceColorComponent } from '@components/common/lead-source-color/lead-source-color';
import { InvoiceNumberingComponent } from '@web-components/settings/invoice-payments-section/components/invoice-numbering/invoice-numbering.component';
import { InsertVariableComponent } from '@components/common/buttons/insert-variable/insert-variable.component';
import { EmailFieldComponent } from '@web-components/common/email-field/email-field.component';
import { TogglePassword } from '@components/common/toggle-password/toggle-password.component';
import { SubscriptionInfoBtn } from '@web-components/admin/subscription-info/subscription-info-btn';
import { DoubleBookingComponent } from '@web-components/common/double-booking/double-booking';
import { EventsOverlappingInfoComponent } from '@web-components/common/double-booking/events-overlapping-info/events-overlapping-info.component';
import { QtTemplatesUpdateComponent } from '@web-components/settings/quote-invoice-templates/qt-templates-update/qt-templates-update.component';
import { QtTemplatesComponent } from '@web-components/settings/quote-invoice-templates/qt-templates/qt-templates.component';
import { NotificationBarComponent } from '@web-components/notification-bar/notification-bar';

import { ReportsOverviewComponent } from '@web-components/admin/report/overview/reports-overview.component';
import { SignupCheckEmailComponent } from '@web-components/login/signup-check-email/signup-check-email.component';

import { TabsPanel } from '@web-components/common/tabs-panel/tabs-panel.component';
import { TabComponent } from '@web-components/common/tabs-panel/tab.component';

import { PaymentMethods } from '@web-components/settings/payment-methods/payment-methods.component';
import { PaymentSchedulesModalComponent } from '@web-components/settings/payment-schedules/modals/payment-schedules-modal/payment-schedules-modal';

const moduleName = 'main';

HybridHelper.downgradeComponent(
	moduleName,
	'autocompleteEmailInput',
	AutocompleteEmailInputComponent,
	{
		inputs: ['isRequired', 'isDisabled', 'placeholder', 'defaultValue'],
		outputs: ['actionGetEmail']
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'uploadComponent',
	UploadComponent,
	{
		inputs: [
			'classComponent',
			'placeHolder',
			'disabled',
			'fileType',
			'componentId'
		],
		outputs: ['action']
	}
);

HybridHelper.downgradeComponent(moduleName, 'togglePassword', TogglePassword, {
	inputs: []
});

HybridHelper.downgradeComponent(
	moduleName,
	'proselectUploadComponent',
	ProselectUploadComponent,
	{
		inputs: [
			'classComponent',
			'placeHolder',
			'disabled',
			'fileType',
			'componentId'
		],
		outputs: ['action']
	}
);

HybridHelper.downgradeComponent(moduleName, 'snLabel', SnLabelComponent, {
	inputs: ['text', 'color']
});

HybridHelper.downgradeComponent(
	moduleName,
	'settingsNavigation',
	SettingsNavigationComponent,
	{
		inputs: []
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'settingsOverview',
	SettingsOverviewComponent,
	{
		inputs: []
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'companiesSection',
	CompaniesSectionComponent,
	{
		inputs: []
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'jobTaskBlock',
	JobTaskBlockComponent,
	{
		outputs: ['editJobModalTrigger']
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'btnSubscription',
	BtnSubscriptionComponent,
	{
		inputs: ['status']
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'snQuillEditorWeb',
	SnQuillEditorWebComponent,
	{
		inputs: [
			'varsList',
			'filesObj',
			'initValue',
			'maxLength',
			'placeholder',
			'editorID',
			'styles',
			'toolbarSettings',
			'imageLoadHandler'
		],
		outputs: ['onAttachmentsChange', 'onTextChange', 'onTextLengthChange']
	}
);

HybridHelper.downgradeComponent(moduleName, 'snWarning', SnWarningComponent, {
	inputs: ['warningClass']
});

HybridHelper.downgradeComponent(
	moduleName,
	'settingsBtn',
	SettingsBtnComponent,
	{
		inputs: ['text', 'isDisabled']
	}
);

HybridHelper.downgradeComponent(moduleName, 'archiveBtn', ArchiveBtnComponent, {
	inputs: ['text'],
	outputs: ['action']
});

HybridHelper.downgradeComponent(
	moduleName,
	'paymentsOverview',
	PaymentsOverviewComponent,
	{
		inputs: [],
		outputs: ['openSendReceiptModalEvent']
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'resubscribeClientModal',
	ResubscribeClientModalWebComponent,
	{
		inputs: ['client'],
		outputs: ['successResubscribeClient', 'cancelResubscribeClient']
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'invoicesViewBlock',
	InvoicesViewBlockComponent,
	{
		inputs: ['jobId', 'leadId', 'isArchived'],
		outputs: ['sendInvoiceEvent', 'createNewInvoiceEvent', 'updateViewEvent']
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'errorMessageModal',
	ErrorMessageModalWebComponent,
	{
		inputs: ['title', 'errorMessage'],
		outputs: []
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'galleryViewBlock',
	GalleryViewBlockComponent,
	{
		inputs: ['job'],
		outputs: []
	}
);

HybridHelper.downgradeComponent(moduleName, 'jobClient', JobClientComponent, {
	inputs: ['client', 'type'],
	outputs: ['onEdit', 'onSend', 'onClientUpdate']
});

HybridHelper.downgradeComponent(moduleName, 'sendBtn', SendBtnComponent, {
	inputs: ['text'],
	outputs: []
});

HybridHelper.downgradeComponent(moduleName, 'editBtn', EditBtnComponent, {
	inputs: ['text', 'isEmpty', 'isLink', 'linkHref', 'isDisabled', 'addClass']
});

HybridHelper.downgradeComponent(
	moduleName,
	'clientPhoto',
	ClientPhotoWebComponent,
	{
		inputs: ['isPhoto', 'clientId']
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'enableGdprSection',
	EnableGdprSectionComponent,
	{
		inputs: ['gdprChecked'],
		outputs: ['enableGdbr']
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'uploadPhotoModal',
	UploadPhotoModalWebComponent,
	{
		inputs: [],
		outputs: []
	}
);

HybridHelper.downgradeComponent(moduleName, 'closeBtn', CloseBtnComponent, {
	inputs: [],
	outputs: ['action']
});

HybridHelper.downgradeComponent(moduleName, 'clientCard', ClientCardComponent, {
	inputs: ['client', 'gdprEnabled'],
	outputs: ['onEdit', 'onSubscribe', 'onDelete']
});

HybridHelper.downgradeComponent(moduleName, 'deleteBtn', DeleteBtnComponent, {
	inputs: ['text', 'isEmpty', 'isDisabled'],
	outputs: []
});

HybridHelper.downgradeComponent(
	moduleName,
	'collapsePanel',
	CollapsePanelComponent,
	{
		inputs: ['title', 'isOpen', 'noCollapsing'],
		outputs: ['toggle']
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'subscribeClientBtn',
	SubscribeClientBtnComponent,
	{
		inputs: ['status', 'isEmpty', 'isDisabled'],
		outputs: []
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'enableClientsOptIn',
	EnableClientsOptInComponent,
	{
		inputs: ['showOtpInConsent', 'id'],
		outputs: ['showOptIn']
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'saveOptinConsentModal',
	SaveOptinConsentModalComponent,
	{
		inputs: ['optinStatement', 'clientId'],
		outputs: ['onSaveOptIn']
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'optInAgreement',
	OptInAgreementComponent,
	{
		inputs: ['data', 'isOptInDisabled'],
		outputs: ['onOptInChange']
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'contractSignature',
	ContractSignatureComponent,
	{
		inputs: ['contract'],
		outputs: []
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'questionnaireSubmittedStatement',
	QuestionnaireSubmittedStatementComponent,
	{
		inputs: ['questionnaire'],
		outputs: []
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'termsUpdatedModal',
	TermsUpdatedModalComponent,
	{
		inputs: [],
		outputs: ['onDisagree', 'onAgree']
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'workflowExitModal',
	WorkflowExitModalComponent,
	{
		inputs: [],
		outputs: []
	}
);
HybridHelper.downgradeComponent(
	moduleName,
	'consentList',
	ConsentListWebComponent,
	{
		inputs: ['consents'],
		outputs: ['deleted']
	}
);

HybridHelper.downgradeComponent(moduleName, 'snSearchbar', SearchbarComponent, {
	inputs: ['placeholder'],
	outputs: ['searchChange']
});

HybridHelper.downgradeComponent(
	moduleName,
	'snPagination',
	SnPaginationComponent,
	{
		inputs: ['pageRequest', 'totalItems', 'pageNumbers'],
		outputs: ['renew']
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'warningSignImg',
	WarningSignImgComponent,
	{
		inputs: [],
		outputs: []
	}
);
HybridHelper.downgradeComponent(
	moduleName,
	'packagesProductBlock',
	PackagesProductBlockComponent,
	{
		inputs: [],
		outputs: []
	}
);
HybridHelper.downgradeComponent(moduleName, 'cancelBtn', CancelBtnComponent, {
	inputs: [],
	outputs: []
});
HybridHelper.downgradeComponent(
	moduleName,
	'shootsAppointmentsBlock',
	ShootsAppointmentsBlockComponent,
	{
		inputs: ['buttonDisabled', 'spinningWheelActive'],
		outputs: ['chooseModalTrigger']
	}
);
HybridHelper.downgradeComponent(
	moduleName,
	'recentLeadsBlock',
	RecentLeadsBlockComponent,
	{
		inputs: ['buttonDisabled', 'spinningWheelActive'],
		outputs: [
			'sendEmailModalTrigger',
			'editLeadModalTrigger',
			'addNewLeadModalTrigger'
		]
	}
);
HybridHelper.downgradeComponent(
	moduleName,
	'upcomingPaymentsBlock',
	UpcomingPaymentsBlockComponent,
	{
		inputs: ['buttonDisabled', 'spinningWheelActive'],
		outputs: []
	}
);
HybridHelper.downgradeComponent(
	moduleName,
	'deleteJobModal',
	DeleteJobModalComponent,
	{
		inputs: ['jobIdForDelete'],
		outputs: ['updateParentTrigger']
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'exportJobsModal',
	ExportJobsModalComponent,
	{
		inputs: [''],
		outputs: ['']
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'deleteLeadModal',
	DeleteLeadModalComponent,
	{
		inputs: ['leadForDelete'],
		outputs: ['updateParentTrigger']
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'exportLeadsModal',
	ExportLeadsModalComponent,
	{
		inputs: [''],
		outputs: ['']
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'jobFileSection',
	JobFileSectionComponent,
	{
		inputs: ['files', 'archived', 'jobId'],
		outputs: ['updateFilesState']
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'eventTypeRow',
	EventTypeRowComponent,
	{
		inputs: ['snFilter', 'eventData'],
		outputs: []
	}
);
HybridHelper.downgradeComponent(
	moduleName,
	'addRoundBtn',
	AddRoundBtnComponent,
	{
		inputs: ['isActive', 'linkHref'],
		outputs: []
	}
);
HybridHelper.downgradeComponent(moduleName, 'reSyncBtn', ReSyncBtnComponent, {
	inputs: ['isActive', 'lastSyncDate'],
	outputs: ['syncEmails']
});
HybridHelper.downgradeComponent(
	moduleName,
	'snQuillViewWeb',
	SnQuillWebViewComponent,
	{
		inputs: ['content']
	}
);
HybridHelper.downgradeComponent(
	moduleName,
	'simplePagination',
	SimplePaginationComponent,
	{
		inputs: ['pageRequest', 'totalPages', 'totalItems'],
		outputs: ['changePageTrigger']
	}
);
HybridHelper.downgradeComponent(
	moduleName,
	'attachments',
	AttachmentsComponent,
	{
		inputs: [],
		outputs: []
	}
);

HybridHelper.downgradeComponent(moduleName, 'userNavbar', UserNavbarComponent, {
	inputs: [],
	outputs: []
});
HybridHelper.downgradeComponent(
	moduleName,
	'dragAndDropBlock',
	DragAndDropBlockComponent,
	{
		inputs: [
			'buttonDisabled',
			'addNewLeadSpinningWheel',
			'isAddNewSpinnningWheelActive',
			'jobTypes'
		],
		outputs: [
			'sendEmailModalTrigger',
			'editLeadModalTrigger',
			'editJobModalTrigger',
			'addNewLeadModalTrigger',
			'chooseModalTrigger'
		]
	}
);
HybridHelper.downgradeComponent(
	moduleName,
	'graphsBlock',
	GraphsBlockComponent,
	{
		inputs: ['jobTypes'],
		outputs: []
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'recordPaymentModal',
	RecordPaymentModalComponent,
	{
		inputs: ['selectedPayment'],
		outputs: ['updateParent']
	}
);
HybridHelper.downgradeComponent(
	moduleName,
	'writeOffModal',
	WriteOffModalComponent,
	{
		inputs: [],
		outputs: []
	}
);
HybridHelper.downgradeComponent(
	moduleName,
	'packageInfoPanel',
	PackageInfoPanelComponent,
	{
		inputs: ['product', 'tax'],
		outputs: ['showAddonDetails']
	}
);
HybridHelper.downgradeComponent(moduleName, 'priceTag', PriceTagComponent, {
	inputs: ['price'],
	outputs: []
});
HybridHelper.downgradeComponent(
	moduleName,
	'quoteSummaryBlock',
	QuoteSummaryBlockComponent,
	{
		inputs: [],
		outputs: []
	}
);
HybridHelper.downgradeComponent(
	moduleName,
	'modalDeleteQuote',
	ModalDeleteQuoteComponent,
	{
		inputs: ['jobId', 'leadId', 'quoteId', 'isLead']
	}
);
HybridHelper.downgradeComponent(
	moduleName,
	'quoteUpdate',
	QuoteUpdateComponent,
	{
		inputs: ['idToGetQuote', 'isJob', 'quoteId', 'quoteType'],
		outputs: []
	}
);

HybridHelper.downgradeComponent(moduleName, 'quoteView', QuoteViewComponent, {
	inputs: ['quoteId', 'jobId', 'data'],
	outputs: ['showSendModal']
});

HybridHelper.downgradeComponent(
	moduleName,
	'invoiceView',
	InvoiceViewComponent,
	{
		inputs: ['invoiceId', 'sendReceiptSpinner'],
		outputs: ['sendMail', 'getContactEmail']
	}
);

HybridHelper.downgradeComponent(moduleName, 'printBtn', PrintBtnComponent, {
	inputs: [],
	outputs: []
});
HybridHelper.downgradeComponent(
	moduleName,
	'modalSendQuote',
	ModalSendQuoteComponent,
	{
		inputs: ['sendMessageData'],
		outputs: []
	}
);
HybridHelper.downgradeComponent(
	moduleName,
	'productDetailsModal',
	ProductDetailsModalComponent,
	{
		inputs: ['product'],
		outputs: []
	}
);
HybridHelper.downgradeComponent(
	moduleName,
	'addonsTable',
	AddonsTableComponent,
	{
		inputs: ['addons'],
		outputs: []
	}
);
HybridHelper.downgradeComponent(
	moduleName,
	'addNewElementBtn',
	AddNewElementBtnComponent,
	{
		inputs: ['icon', 'imgSrc', 'title', 'description'],
		outputs: ['onBtnClicked']
	}
);
HybridHelper.downgradeComponent(
	moduleName,
	'addQuoteTypeModal',
	AddQuoteTypeModalComponent,
	{
		inputs: [],
		outputs: ['onQuoteTypeSelected']
	}
);
HybridHelper.downgradeComponent(
	moduleName,
	'invoiceUpdateDnd',
	InvoiceUpdateDnd,
	{
		inputs: ['products', 'companyCurrencyAndTaxes', 'productsNames'],
		outputs: []
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'productPackageTable',
	ProductPackageTableComponent,
	{
		inputs: ['data', 'currencySymbol', 'summary'],
		outputs: []
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'invoiceUpdate',
	InvoiceUpdateComponent,
	{
		inputs: ['dataToGetInvoice'],
		outputs: []
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'contactFormSection',
	ContactFormSectionComponent
);

HybridHelper.downgradeComponent(
	moduleName,
	'questionnaireSection',
	QuestionnaireSectionComponent
);

HybridHelper.downgradeComponent(
	moduleName,
	'dateTimeCalendar',
	DateTimeCalendarComponent
);

HybridHelper.downgradeComponent(
	moduleName,
	'customizeLabels',
	CustomizeLabelsComponent
);

HybridHelper.downgradeComponent(
	moduleName,
	'emailReplyModal',
	EmailReplyModalComponent,
	{
		inputs: ['emailData', 'disableBtn'],
		outputs: ['onSaveSettings', 'onModalClose']
	}
);

HybridHelper.downgradeComponent(moduleName, 'profile', ProfileComponent, {
	inputs: [],
	outputs: []
});

HybridHelper.downgradeComponent(
	moduleName,
	'subscription-announcement-banner',
	SubscriptionAnnouncementBannerComponent,
	{
		inputs: [],
		outputs: []
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'subscription-choose-plan',
	SubscriptionChoosePlanComponent,
	{
		inputs: [],
		outputs: []
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'settingSectionHeader',
	SettingSectionHeaderComponent,
	{
		inputs: ['breadcrumbs'],
		outputs: []
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'settingSectionDescription',
	SettingSectionDescriptionComponent,
	{
		inputs: ['text'],
		outputs: []
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'editCompanySection',
	EditCompanySectionComponent,
	{
		inputs: ['companyId'],
		outputs: []
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'questionnaire',
	QuestionnaireComponent,
	{
		inputs: ['jobId', 'questionnaireId', 'companyImageSrc'],
		outputs: ['questionnaireSend', 'questionnaireDelete']
	}
);

HybridHelper.downgradeComponent(moduleName, 'smtpModal', SmtpModalComponent, {
	inputs: ['smtpData'],
	outputs: ['onSaveSmtp']
});

HybridHelper.downgradeComponent(
	moduleName,
	'integrationsSection',
	IntegrationsSection,
	{
		inputs: ['routeParams'],
		outputs: ['']
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'editContractButton',
	EditContractButton,
	{
		inputs: ['contract'],
		outputs: ['reInitContract']
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'saveContractPdf',
	SaveContractPdf,
	{
		inputs: ['contract'],
		outputs: ['']
	}
);

HybridHelper.downgradeComponent(moduleName, 'downloadLog', DownloadLog, {
	inputs: ['contract'],
	outputs: ['']
});

HybridHelper.downgradeComponent(
	moduleName,
	'integrateWithXeroNewModal',
	IntegrateWithXeroV2Modal,
	{
		inputs: ['connectionsData'],
		outputs: ['xeroConnectState']
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'manageUserTwoFa',
	ManageUser2faModal,
	{
		inputs: ['twoFaInfo', 'businessAccountId'],
		outputs: ['closeModal']
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'leadSourcesSection',
	LeadSourcesSectionComponent,
	{
		inputs: [],
		outputs: []
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'leadSourceColor',
	LeadSourceColorComponent,
	{
		inputs: ['color', 'borderShadePercentage'],
		outputs: []
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'invoiceNumbering',
	InvoiceNumberingComponent,
	{
		inputs: [],
		outputs: []
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'insertVariable',
	InsertVariableComponent,
	{
		inputs: ['variableListType'],
		outputs: ['onVariableChoose']
	}
);

HybridHelper.downgradeComponent(moduleName, 'emailField', EmailFieldComponent, {
	inputs: ['value', 'disabled', 'placeholder'],
	outputs: ['valueChange']
});

HybridHelper.downgradeComponent(
	moduleName,
	'subscriptionInfoBtn',
	SubscriptionInfoBtn,
	{
		inputs: ['user'],
		outputs: ['isDisabled']
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'doubleBooking',
	DoubleBookingComponent,
	{
		inputs: ['doubleBooking'],
		outputs: []
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'eventsOverlappingInfo',
	EventsOverlappingInfoComponent,
	{
		inputs: ['data'],
		outputs: []
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'qtTemplates',
	QtTemplatesComponent,
	{
		inputs: [],
		outputs: []
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'qtTemplatesUpdate',
	QtTemplatesUpdateComponent,
	{
		inputs: ['templateId', 'templateType', 'templateAction'],
		outputs: []
	}
);

HybridHelper.downgradeComponent(moduleName, 'saveNewTemplateModal', {
	inputs: ['templateTypeName', 'btnDisable', 'breadcrumbsText'],
	outputs: ['closeModal']
});

HybridHelper.downgradeComponent(
	moduleName,
	'notificationBar',
	NotificationBarComponent,
	{
		inputs: ['isShowNotificationBar'],
		outputs: ['isShowNotificationBar']
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'reportsOverview',
	ReportsOverviewComponent,
	{
		inputs: []
	}
);

HybridHelper.downgradeComponent(
	moduleName,
	'signupCheckEmail',
	SignupCheckEmailComponent,
	{
		inputs: ['firstName', 'textHtml', 'titleHtml']
	}
);

HybridHelper.downgradeComponent(moduleName, 'tabsPanel', TabsPanel, {
	inputs: []
});

HybridHelper.downgradeComponent(moduleName, 'tabComponent', TabComponent, {
	inputs: ['tabTitle', 'highlight']
});

HybridHelper.downgradeComponent(moduleName, 'paymentMethods', PaymentMethods, {
	inputs: []
});

HybridHelper.downgradeComponent(
	moduleName,
	'paymentSchedulesModal',
	PaymentSchedulesModalComponent,
	{
		inputs: ['title', 'paymentSchedule'],
		outputs: ['saved', 'error']
	}
);



// WEBPACK FOOTER //
// ./web/js/components/downgradedComponents.js